import { VaccineModel } from '../model/vaccine.model';
import { vaccinationsData } from '../assets/data/vaccinations.data';
import { TFunction } from 'i18next';

export const mapVaccinations = (codes: string[], t: TFunction): VaccineModel[] => {

    return codes.map(code => {
        const showDisclaimer = code.includes('_1') || code.includes('_2') || code.includes('GR_HD');
        const vaccine = vaccinationsData[code];

        if (!vaccine) {
            return {
                abbreviation: code,
                fullName: code,
                disclaimer: "",
                leaflet: "",
                chpl: [],
                vaccinationSchema_18_49: "",
                vaccinationSchema_50_54: "",
                vaccinationSchema_55_59: "",
                vaccinationSchema_60_64: "",
                vaccinationSchema_65: "",
                vaccinationSchema_pregnant: "",
                showDisclaimer: showDisclaimer
            };
        }

        return {
            ...vaccine,
            fullName: t(vaccine.fullName, vaccine.fullName),
            disclaimer: t(vaccine.disclaimer, vaccine.disclaimer),
            vaccinationSchema_18_49: t(vaccine.vaccinationSchema_18_49, vaccine.vaccinationSchema_18_49),
            vaccinationSchema_50_54: t(vaccine.vaccinationSchema_50_54, vaccine.vaccinationSchema_50_54),
            vaccinationSchema_55_59: t(vaccine.vaccinationSchema_55_59, vaccine.vaccinationSchema_55_59),
            vaccinationSchema_60_64: t(vaccine.vaccinationSchema_60_64, vaccine.vaccinationSchema_60_64),
            vaccinationSchema_65: t(vaccine.vaccinationSchema_65, vaccine.vaccinationSchema_65),
            vaccinationSchema_pregnant: t(vaccine.vaccinationSchema_pregnant, vaccine.vaccinationSchema_pregnant),
            showDisclaimer: showDisclaimer
        };
    });
};
